import React from 'react';
import { HeroSection } from './HeroSection';
import { PainSection } from './PainSection';
import { LieSection } from './LieSection';
import { ThreeDoorsSection } from './ThreeDoorsSection';
import { ProductIntro } from './ProductIntro';
import { BenefitsSection } from './BenefitsSection';
import { ForWhoSection } from './ForWhoSection';
import { IncludesSection } from './IncludesSection';
import { PricingSection } from './PricingSection';
import { FinalCTA } from './FinalCTA';
import { Footer } from './Footer';
export function SalesPage() {
  return <main className="min-h-screen bg-[#0A0A0A]" data-id="element-234">
      <HeroSection data-id="element-235" />
      <PainSection data-id="element-236" />
      <LieSection data-id="element-237" />
      <ThreeDoorsSection data-id="element-238" />
      <ProductIntro data-id="element-239" />
      <BenefitsSection data-id="element-240" />
      <ForWhoSection data-id="element-241" />
      <IncludesSection data-id="element-242" />
      <PricingSection data-id="element-243" />
      <FinalCTA data-id="element-244" />
      <Footer data-id="element-245" />
    </main>;
}